<template>

  <b-modal
    id="modal-edit-view"
    ref="modal-edit-view"
    size="lg"
    hide-footer
    :title="$t('Add Record',{ label : label })"
    no-close-on-backdrop
  >
    <edit-view-form
      ref="edit-view-form"
      :fields="fields"
      :module="module"
      @onSubmitForm="submitForm"
    />
  </b-modal>
</template>

<script>

import {
  BModal,
} from 'bootstrap-vue'
import { getSingleLabelByModuleName } from '@/utils/utils'
import EditViewForm from './EditViewForm.vue'

export default {
  name: 'EditViewModal',
  components: {
    BModal,
    EditViewForm,
  },
  props: {
    module: {
      type: String,
      default: () => '',
    },
    fields: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      label: '',
    }
  },
  watch: {
    module: 'updateLabel',
  },
  created() {
    this.updateLabel()
  },
  methods: {
    submitForm(data) {
      this.$emit('onSubmitForm', data)
    },
    updateLabel() {
      this.label = getSingleLabelByModuleName(this.module)
    },
  },
}
</script>

<style scoped>

</style>
